import {Component, OnInit} from '@angular/core';
import {AppService} from '../app.service';
import {CardImage, ImageType} from "../CardCreator/CardImage";
import cardBacks, {CardBack, CardHole, HoleType} from "../CardCreator/CardBacks";
declare let $: any;
declare let window: any;

@Component({
  selector: 'create-console-mobile',
  templateUrl: './createConsoleMobile.component.html',
  styleUrls: ['./createConsoleMobile.component.css', '../app.component.css']
})
export class CreateConsoleMobileComponent implements OnInit {
  cardBackList: CardBack[] = cardBacks;
  cardBackHeight = 0;
  showOptions = false;
  showManageOptions = false;
  showAddImage = false;
  showCrop = false;
  showCards = false;
  showCutout = false;
  showFrame = false;
  showText = false;
  mainTabSel = 1;
  secondaryTabSel = 4;
  textRefreshTimer = null;
  tertiaryTabSel = 1;
  showCreatedCards = false;
  passedInit = false;
  savedCardWidth = 0;

  constructor(public app: AppService) {

  }

  savedCardClicked(card) {
    this.app.selectedSavedCard = card;
    this.app.cardAdChanged = false;
    this.showCreatedCards = false;
    console.log("Card clicked: ", card);
    this.app.broadcast({event: 'selCardChanged'});
  }

  savedCardStyle(cardBack) {
    let usedWidth = 0;
    if (!this.passedInit) {
      let el = document.getElementById("savedCard" + cardBack.id);
      if (!el) {
        return {};
      }
      usedWidth = el.clientWidth;
      this.savedCardWidth = usedWidth;
    } else {
      usedWidth = this.savedCardWidth;
    }
    return (this.app.selectedSavedCard && cardBack.id === this.app.selectedSavedCard.id) ?
      {'border': '1px solid green'} :
      {'border': '1px solid black'};
  }

  expandSavedTabClicked() {
    this.showCreatedCards = !this.showCreatedCards;
    console.log("Expand saved tab");
    if (this.app.selectedSavedCard !== null) {
      setTimeout(() => {
        console.log("Here", this.app.selectedSavedCard);
        var pos = $('#savedCard' + this.app.selectedSavedCard.id).offset().top;
        console.log("Auto scroll to pos: ", pos);
        $('#savedCardList').scrollTop(pos);
        console.log("Did scroll");
      }, 300)
    }
  }

  expandTabClicked() {
    console.log("Expand tab clicked");
    this.showOptions = !this.showOptions;
    this.app.showIntro = false;
  }

  getThemeBackground() {
    switch(this.app.theme) {
      case 0:
        return "./assets/Background-1.jpg";
      case 1:
        return "./assets/Background-2.jpg";
      case 2:
        return "./assets/Background-6.jpg";
      case 3:
        return "./assets/Background-3.2.jpg";
      default:
        return "./assets/Background-1.jpg";
    }
  }

  getImageTabStyle() {
    return (this.app.selectedImage !== null && this.app.selectedImage.type === ImageType.image && false) ?
      {'background-color': '#EEE1B7'} : {}
  }

  expandTabTapped(type: number, tab: number) {
    this.showManageOptions = type === 0 && !this.showManageOptions;
    this.showAddImage = type === 1 && !this.showAddImage;
    this.showCrop = type === 2 && !this.showCrop;
    this.showCards = type === 3 && !this.showCards;
    this.showCutout = type === 4 && !this.showCutout;
    this.showFrame = type === 7 && !this.showFrame;
    this.showText = type === 5 && !this.showText;
    this.app.showReady = type === 6 && !this.app.showReady;
    if (type === 6) {
      this.app.viewMode = 1;
      this.app.broadcast({event: 'makeSnapshot'});
    }
    if (tab === 0) return;
    if (type === 2 && this.app.inCropMode) return;
    if (type === 2 && !this.app.inCropMode && this.app.creating.cardImage.length > 0) {
      this.app.selectedImage = this.app.creating.cardImage[0];
    }
    if (type === 7) {
      console.log("Select Frame");
    }
    if (this.showCards && this.app.creating.cardBack.id > 1) {
      //Scroll to last selected card
      setTimeout(() => {

        var pos = $('#cardBack' + this.app.creating.cardBack.id).offset().top;
        console.log("Auto scroll to pos: ", pos);
        $('#cardBackList').scrollTop(pos);
      }, 300);
    }
    this.secondaryTabClick(tab);
  }

  changeTextBackgroundShape(shape: number) {
    this.app.selectedImage.textSetup.shape = shape;
    this.app.broadcast({event: 'updateEditingCanvas'});
  }

  removeImage(text: CardImage) {
    this.app.creating.cardText = this.app.creating.cardText.filter((t) => {
      return t.id !== text.id;
    });
    this.app.broadcast({event: 'updateEditingCanvas'});
  }

  textImageClicked(text: CardImage) {
    this.app.creating.cardText.forEach((t) => {
      t.resizable = false;
    });
    this.app.selectedImage = text;
    text.resizable = true;
    this.app.broadcast({event: 'updateEditingCanvas'});
  }

  ngOnInit() {
    this.app.broadcaster.subscribe((value) => {
      this.broadCastHandle(value);
    });
    if (!this.passedInit) {
      setTimeout(() => {
        this.passedInit = true;
        console.log("Setting passed init");
      }, 2000);
    }
  }

  broadCastHandle(value: Object): void {
    switch (value['event']) {
      case 'hadImageAdded':
        // setTimeout(() => {
        //   this.secondaryTabClick(5);
        // }, 300);
        break;
      case 'viewMyCards':
        console.log("Switch to manage cards");
        this.mainTabClick(2);
        break;
      case 'imageSaved':
        this.mainTabClick(2, false);
        break;
      case 'customSwitch':
        this.tertiaryTabClick(3);
        break;
      case 'setTertiaryOne':
        this.mainTabSel = 2;
        this.tertiaryTabSel = 1;
        break;
      case 'advertisementSwitch':
        this.tertiaryTabClick(2);
        break;
      case 'backToCardCreation':
        this.mainTabClick(1);
        this.app.showIntro = true;
        this.app.viewMode = 0;
        setTimeout(() => {
          this.app.broadcast({event: 'backToCreation'});
        }, 500);
        break;
      case 'editCard':
        let card = value['data'];
        setTimeout(() => {
          this.mainTabClick(1);
        }, 300);
        break;
      case 'purchaseFinished':
        setTimeout(() => {
          this.tertiaryTabClick(1);
          this.app.errorText = "Thank you for your purchase!";
          setTimeout(() => {
            $('#errorModal').modal('show');
          }, 500);
        }, 300);
        break;
      case 'addMoreImpressions':
        console.log("Got here to add more impressions");
        this.mainTabClick(2);
        setTimeout(() => {
          this.tertiaryTabClick(2);
        }, 300);
        break;
      default:
        break;
    }
  }

  mainTabClick(tab, showCreated = true) {
    console.log("Main tab clicked: ", tab);
    switch(tab) {
      case 1:
        this.secondaryTabSel = 4;
        break;
      case 2:
        if (this.app.loggedIn) {
          this.tertiaryTabClick(1);
          this.showOptions = false;
          this.showCreatedCards = showCreated;
        } else {
          this.app.defer = () => {
            this.mainTabSel = tab;
            this.tertiaryTabClick(1);
          };
          $('#loginModal').modal('show');
          return;
        }
        break;
      case 3:
        this.app.broadcast({event: 'cardBackClicked', card: this.app.selectedSavedCard});
        break;
      default:
        break;
    }
    this.mainTabSel = tab;
  }

  secondaryTabClick(tab) {
    console.log("Secondary Tab click: ", tab);
    switch(tab) {
      case 1: //Sel Back
        break;
      case 2: //Change Hue
        break;
      case 3: //Canvas Color
        break;
      case 4: //Add Image
              // setTimeout(() => {
              //   this.secondaryTabClick(1);
              // }, 300);
        break;
      case 5: //Format Image
        if (!this.app.hasImageAdded) {
          console.log("No image added");
          this.app.errorText = "Please add an image first.";
          $('#errorModal').modal('show');
          return;
        }
        break;
      case 6: //Add Text
        setTimeout(() => {
          this.secondaryTabClick(7);
        }, 300);
        return;
      case 7: //Customize Text
        if (this.app.creating.cardText.length > 0 && this.showText) {
          this.app.creating.cardText.forEach((t) => {
            t.resizable = false;
          })
          this.app.selectedImage = this.app.creating.cardText[0];
          this.app.selectedImage.resizable = true;
        }
        break;
      case 8: //Finish Card
        break;
      case 9: //Crop card
        break;
      case 10:
        if (this.app.creating.cardHoles.length === 0) {
          this.app.creating.cardHoles.push(new CardHole(0, 25, 25, 50, 50,
            true, HoleType.none, false));
        }
        this.app.creating.cardHoles[0].resizing = true;
        break;
      case 11: //Manage Card Tab

        break;
      default:
        break;
    }
    if (tab !== 4) {
      this.app.creating.cardImage.forEach((i) => {
        i.resizable = false;
      });
      if (this.app.selectedImage !== null && this.app.selectedImage.type === ImageType.image) {
        this.app.selectedImage = null;
      }
    }
    if (tab !== 6 && tab !== 7) {
      this.app.creating.cardText.forEach((h) => {
        h.resizable = false;
      });
      if (this.app.selectedImage !== null && this.app.selectedImage.type === ImageType.text) {
        this.app.selectedImage = null;
      }
    }
    if (tab !== 10) {
      this.app.creating.cardHoles.forEach((h) => {
        h.resizing = false;
      });
    }
    this.secondaryTabSel = tab;
    this.app.broadcast({event: 'editTabChanged', data: tab});
  }

  tertiaryTabClick(tab) {
    switch(tab) {
      case 1:
        break;
      case 2:
        console.log("Here");
        if (!this.app.selectedSavedCard) {
          this.app.errorText = "Please select a card back to view the sponsor setup.";
          $('#errorModal').modal('show');
          return;
        }
        break;
      case 3:
        if (!this.app.selectedSavedCard) {
          this.app.errorText = "Please select a card back to view the custom setup.";
          $('#errorModal').modal('show');
          return;
        }
        break;
      default:
        break;
    }
    this.tertiaryTabSel = tab;
  }

  changeCardHole(type: number, option: number) {
    var h: CardHole = this.app.creating.cardHoles[0];
    if (h.type !== type || h.option !== option) {
      this.updateHoleDimensions(h, option);
    }
    this.app.creating.cardHoles[0].type = type;
    this.app.creating.cardHoles[0].option = option;
    this.app.broadcast({event: 'updateEditingCanvas'});
  }

  updateHoleDimensions(h: CardHole, option: number) {
    h.x = option === 1 ? 7.5 : 12.5;
    h.y = option === 2 ? 12.5 : (option === 1 ? 30 : 25);
    h.width = option === 1 ? 85 : 75;
    h.height = option === 2 ? 75 : (option === 1 ? 40 : 50);
    h.hadValsSet = false;
  }

  getHoleOptionStyle(holeType: number, option: number) {
    if (this.app.creating.cardHoles.length === 0) {
      return {'border': '1px solid black', 'padding': '10px'};
    }
    return (holeType === this.app.creating.cardHoles[0].type && option === this.app.creating.cardHoles[0].option) ?
      {'border': '1px solid green', 'box-shadow' : '1px 1px 7px 2px #ffd11a', 'padding': '10px'} :
      {'border': '1px solid black', 'padding': '10px'};
  }

  decreaesBorderWidth() {
    this.app.creating.cardHoles[0].borderWidth = this.app.creating.cardHoles[0].borderWidth - 1;
    this.app.broadcast({event: 'updateEditingCanvas'});
  }

  increaseBorderWidth() {
    this.app.creating.cardHoles[0].borderWidth = this.app.creating.cardHoles[0].borderWidth + 1;
    this.app.broadcast({event: 'updateEditingCanvas'});
  }

  holeBorderChanged() {
    this.app.broadcast({event: 'updateEditingCanvas'});
  }

  cropImageToFrame() {
    this.app.broadcast({event: 'cropImageToFrame'});
  }

  cardBackClicked(cardBack: CardBack) {
    console.log("Card back clicked: ", cardBack);
    this.app.broadcast({event: 'cardBackSelected', data: cardBack});
    if (cardBack.id !== 0 && this.app.creating.cardHoles.length > 0) {
      if (this.app.creating.cardHoles[0].type === HoleType.none) {
        this.showCards = false;
        this.showCutout = true;
      } else {
        this.showCards = false;
      }
    }
  }

  getCardBackDisplayStyle(cardBack) {
    let el = document.getElementById("cardBack" + cardBack.id);
    if (!el) {
      return {};
    }
    let height = el.clientHeight;
    let width = el.clientWidth;

    cardBack.width = width - 30;
    cardBack.height = Math.ceil((width - 30) * 1.4463);
    cardBack.elHeight = height;
    this.cardBackHeight = height;
    let margin = 10;
    if (cardBack.elHeight) {
      margin = Math.ceil((cardBack.elHeight - cardBack.height) / 2);
    }
    return cardBack.id === this.app.creating.cardBack.id ?
      {'border': '1px solid green', 'box-shadow' : '1px 1px 7px 2px #ffd11a', 'padding': '10px',
        'height': (Math.ceil((width - 10) * 1.6)) + 'px'} :
      {'border': '1px solid black', 'padding': '10px', 'height': (Math.ceil((width - 10) * 1.6)) + 'px'};
  }

  getBlankCardStyle(cardBack) {
    if (!cardBack.elHeight || this.cardBackHeight < 100) {
      return {'display': 'none'};
    }
    if (!this.app.hasRunBlankRefresh) {
      this.app.hasRunBlankRefresh = true;
      setTimeout(() => {
        let cb = $('#cardBack0');
        if (cb !== null) {
          cb.click();
        }
      });
    }

    return {'line-height': this.cardBackHeight + 'px', 'height': this.cardBackHeight + 'px'};
  }

  getTabStyle(tab) {
    switch(tab) {
      case 1:
        return this.tertiaryTabSel !== 1 ? {'background-color': '#56a9b2'} : '';
      case 2:
        if (!this.app.selectedSavedCard) {
          return {'opacity': 0.3, 'pointer-events': 'none', 'cursor': 'not-allowed'};
        }
        if (this.tertiaryTabSel !== 2) {
          return {'background-color': '#56a9b2'};
        }
        break;
      case 3:
        if (!this.app.selectedSavedCard) {
          return {'opacity': 0.3, 'pointer-events': 'none', 'cursor': 'not-allowed'};
        }
        if (this.tertiaryTabSel !== 3) {
          return {'background-color': '#56a9b2'};
        }
        break;
      default:
        break;
    }
    return {};
  }

  countTextObjects() {
    return this.app.images.filter((i) => {
      return i.type === "text";
    }).length;
  }

  getConsoleHeight() {
    let height = window.innerHeight;
    if (height < 800) {
      return {'height': 800 + 'px'};
    }
    return {'height': (height - 75) + 'px'}
  }

  colorChanged() {
    console.log("Color changed");
    this.setUpdatePreview();
    this.app.fireColorChangeEvent();
  }

  setUpdatePreview() {
    this.app.broadcast({event: 'setUpdatePreview'});
  }

  addImage() {
    this.showAddImage = false;
    this.app.broadcast({event: 'addImage'});
  }

  addTextImage() {
    this.app.broadcast({event: 'addTextImage'});
  }

  getItemTabStyle(item) {
    let imageBackColor = "#ffd11a";
    let textBackColor = "#54DCE2";
    let isSel = this.checkIfIsSel(item);
    return isSel ? {color: 'white', 'font-size': '19px'} : {};
  }

  checkIfIsSel(item) {
    return item.id === this.app.selectedImage.id &&
      item.x === this.app.selectedImage.x &&
      item.y === this.app.selectedImage.y &&
      item.height === this.app.selectedImage.height &&
      item.width === this.app.selectedImage.width;
  }

  imageClicked(image) {
    this.app.selectedImage = image;
    this.showAddImage = false;
    this.app.broadcast({event: 'updateEditingCanvas'});
  }

  editImage() {
    this.showAddImage = false;
    this.app.selectedImage = this.app.creating.cardImage[0];
    this.app.broadcast({event: 'editImage'});
  }

  getListPosition() {
    let el = document.getElementById("fontListButton");
    let top = el.offsetTop;
    let left = el.offsetLeft;
    return {top: (top + 30) + 'px', left: left + 'px', 'max-height': '200px', 'overflow': 'scroll'};
  }

  updateFont(font) {
    this.app.broadcast({'event': 'updateFont', 'data': font});
  }

  textBoxFocus() {
    console.log("Text box focus: ", this.app.selectedImage.textSetup.text);
    if (this.app.selectedImage.textSetup.text === '(Type Here)') {
      this.app.selectedImage.textSetup.text = "";
    }
  }

  updateTextBox(){
    this.app.broadcast({event: 'updateTextBox'});
  }

  textBoxColorChange() {
    this.app.broadcast({event: 'updateTextBox'});
    this.app.fireColorChangeEvent();
  }

  textBoxPressed() {
    if (this.app.selectedImage.textSetup.text === "(Type Here)") {
      this.app.selectedImage.textSetup.text = '';
    }
  }

  startTextRefreshTimer() {
    if (this.textRefreshTimer !== null) {
      clearTimeout(this.textRefreshTimer);
    }
    this.textRefreshTimer = setTimeout(() => {
      this.updateTextBox();
    }, 500);
  }

  cropSquare() {
    this.showCrop = false;
    this.app.broadcast({event: 'runCropSquare'});
  }

  cropCircle() {
    this.showCrop = false;
    this.app.broadcast({event: 'runCropCircle'});
  }

  runAcceptCrop() {
    this.showCrop = false;
    this.app.broadcast({event: 'runAcceptCrop'});
  }

  runCancelCrop() {
    this.showCrop = false;
    this.app.broadcast({event: 'runCancelCrop'});
  }

  acceptCrop() {
    console.log("Accept crop");
    this.app.broadcast({event: 'cropImage'});
    setTimeout(() => {
      this.secondaryTabClick(5)
    }, 300);
  }

  createNewCard() {
    this.showOptions = false;
    this.app.broadcast({event: 'createNewCard'});
  }

  overwriteCard() {
    this.app.broadcast({event: 'overwriteCard'});
  }

  getTextObjects() {
    return this.app.images.filter((f) => {
      return f.type === "text";
    });
  }
}
